import { PAGE_TITLES } from "@miplatform/constants";
import { Inspections } from "../../views";
import { CreateNewInspection } from "../../views/Inspections/CreateNewInspection/CreateNewInspection";

export const inspectionsRoutes = [
  {
    path: "/inspections",
    name: "Inspections",
    element: <Inspections />,
  },
  {
    path: "/inspections/:calendarSetId/:calendarId",
    name: "Inspections",
    element: <Inspections />,
  },
  {
    path: "/inspections/:calendarSetId",
    name: "Inspections",
    element: <Inspections />,
    handle: { title: PAGE_TITLES.INSPECTIONS },
  },
  {
    path: "/inspections/create",
    name: "Inspections",
    element: <CreateNewInspection />,
    handle: { title: PAGE_TITLES.NEW_INSPECTION },
  },
];
